import SpokeRoundedIcon from "@mui/icons-material/SpokeRounded";
import { Skeleton } from "@mui/material";

import "./styles.css";
import { VerifiedRounded } from "@mui/icons-material";

import { Text } from "@fragments";


export function CommunityBanner({ banner, small = false, size = 48, className = "" }) {

  size = small ? 32 : size;

  return (
    <div
      className={"community-banner-block " + (small && "banner-small") + " " + className}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        maxWidth: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        maxHeight: `${size}px`,
      }}
    >
      {banner ? <img src={banner} /> : <SpokeRoundedIcon />}
    </div>
  );
}

export function UserAvatar({
  user,
  size = 48,
  small = false,
  loading = false,
  className = "",
  style = {},
  displayName = false,
  displayNickname = false
}) {
  if (loading) {
    return (
      <Skeleton
        variant="circular"
        width={size}
        height={size}
        className={className}
        style={style}
      />
    );
  }



  function Avatar() {
    const cleanAvatarUrl = user.avatar

    return (
      <div
        className={"user-banner " + (small && " banner-small ")}
        style={{
          width: size,
          height: size,
          maxWidth: size,
          maxHeight: size
        }}
      >
        {cleanAvatarUrl ? (
          <img src={cleanAvatarUrl} />
        ) : (
          <span className="bold">
            {user?.username
              ?.split(" ")
              .slice(0, 2)
              .map((c) => c.split('')[0])}
          </span>
        )}
      </div>
    )
  }

  if (!user) return null;

  const NameComponent = size > 25 ? Text.h5 : Text.span;

  return (
    <div className={"user-card-container " + className} style={style}>
      <Avatar />
      {
        displayName && (
          <div className="user-card-name-container">
            {
              displayName && (
                <NameComponent contrast={8} weight={size > 25 ? 500 : 300} className="user-card-name">
                  {user?.username}
                  {user?.verified ? <VerifiedRounded
                    style={{ marginLeft: '3px', color: 'var(--primary-6)', fontSize: size > 25 ? '16px' : '12px' }}
                    className="verified-icon"

                  /> : null}
                </NameComponent>
              )
            }
            {
              displayNickname && user?.nickname && (
                <Text.span weight={size > 25 ? 300 : 200} contrast={4} className="user-card-nickname">
                  @{user?.nickname}
                </Text.span>
              )
            }
          </div>
        )
      }

    </div>
  );
}
